import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer-landing',
  templateUrl: './footer-landing.component.html',
  styleUrls: ['./footer-landing.component.css']
})
export class FooterLandingComponent implements OnInit {

  @Input() companyName;
  currentYear;

  today = null;
  totalWebVisits = 0;
  myAccummulate = 0;

  constructor(private router: Router) {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var accumulate = 30*month+day;
    this.today = year + "/" + month + "/" + day;
    this.totalWebVisits = accumulate + this.myAccummulate;
    this.currentYear =dateObj.getUTCFullYear();
  }


  goToFunnel() {
    this.router.navigateByUrl('/funnel');
  }

  goToCalendlyPage() {
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02')
  }

  goToTravelersPage() {
    this.router.navigateByUrl('/travelers-page');
  }

  goToHomePage(){
    window.open('https://voyjaleas.com');
  }

  ngOnInit(): void {

  }

  getNumber() {
    return this.totalWebVisits;
  }

}
